import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class UrlConstants {
  static login = '/cebq-svc/?cdxRedirectPath=/';
  static getProfileUri	= '/userdetails';

  // API end points
  static HEALTH_CHECK = 'ebtq-svc/healthCheck';
  static HOLIDAY_URL = 'getHolidays';
  static GSEAMT_URL = 'getGSEAmtByState';
  static MAXAMT_URL = 'getMAXAmtByState';
  static UPDATE_GSEAMT_URL = 'updateGSEAmtByState';
  static UPDATE_MAXAMT_URL = 'updateMAXAmtByState';
  static GSEAMTLIST_URL = 'getGSEAmtList';
  static MAXAMTLIST_URL = 'getMAXAmtList';
  static GETSYSATTR_URL = 'getSysAttrMap';
  static GET_VALUE_CACHE = 'getValueCache';
  static SEARCH_UPDATE = 'findLoanAllKeys';
  static SEARCH_UPDATE_BY_PRIMARY_KEYS = 'findByLoanPrimaryKey';
  static CURRENTPROCESSINGDATE_URL = 'currentProcessingDate';
  static GETUPDTATTR_URL = 'updateSysAttr';
  static INSERT_RSS_ENTRY = 'insertRSSEntry';
  static GET_SEASONED_LOAN_FEE_URL = 'getSeasonedLoanFeeDetail';
  static GET_UPDATE_LOAN_FEE_URL = 'updateSeasonedLoanFeeDetail';
  static GET_ADD_SEASON_LOAN_FEE_DETAIL_URL = 'addSeasonedLoanFeeDetail';
  static GET_DELETE_SEASON_LOAN_FEE_DETAIL_URL = 'deleteSeasonedLoanFeeEntry';
  static EXECUTE_QUERY_PPA = 'executeQueryForPPA';
  static UPDATE_QUERY_PPA = 'updatePPA';
  static GET_LOAN_DETAILS = 'executeQueryLoan';
  static GET_QUERY_LOAN_DETAILS = 'executeQueryLoanDetail';
  static EXECUTE_QUERY = 'executeQuery';
  static EXECUTE_SUBMIT_TRIAL = 'submitTrialBalance';
  static EXECUTE_ACCT_VIEW_PURCHASE_ADVICE = 'accountingViewPurchaseAdvice';
  static EXECUTE_DEL_VIEW_PURCHASE_ADVICE = 'deliveryViewPurchaseAdvice';
  static QUERY_PAYOFF = 'queryPayoff';
  static QUERY_PRE_PAYMENT = 'executePartialPrepaymentTransaction';
  static QUERY_PAYMENT_CHANGE = 'executePaymentChangeUserTransaction';
  static LOAN_STATUS_MAINTEN = 'executeLoanStatusMaintenanceTransaction';
  static EXECUTE_TRANSACTION_REVERSAL = 'executeTransactionReversal';
  static EXECUTE_QUERY_TRANS = 'executeQueryTrans';
  static EXECUTE_QUERY_SERVICE_TRANSFER = 'executeQueryServiceTransfer';
  static CDXToS3Bucket = 'pushCDXToS3Bucket';
  static TRANSACTION_PAYOFF = 'executePayoffTransaction';
  static UNSCHEDULED_PAYOFF = 'executeUnscheduledPaymentUserTransaction';
  static GET_SELL_SER_NUMBER = 'getRMSecureuser';
  static GET_USER_CONTACT_INFO = 'getUserContactInfo';
  static UPDATE_CONTACT_INFO = 'updateContactInfo';
  static GET_REPORT = 'downloadReport';
  static GET_REPORT_BY_LN_NUMBER = 'getReportByLoanNumber';
  static ADHOC_REPORT = 'adhocReport';
  static GET_ADHOC_REPORT = 'retrieveAdhocReport';
  static GET_PURCHASSE_ADVICE_CSV = 'getPurchaseAdviceCsvReport';

  static getServer() {
    const hostname = window && window.location && window.location.hostname;
    if (/^localhost/.test(hostname)) {
      return environment.local.prefix;
    } else if (/cebq.cdxms.devl-etss/.test(hostname)) {
      return environment.devl.prefix;
    } else if (/eboutique.cebq.sfbu.devl/.test(hostname)) {
      return environment.devext.prefix;
    } else if (/cebq.cdxms.test-etss/.test(hostname)) {
      return environment.test.prefix;
    } else if (/eboutique.cebq.sfbu.test/.test(hostname)) {
      return environment.testext.prefix;
    } else if (/cebq.cdxms.acpt-etss/.test(hostname)) {
      return environment.acpt.prefix;
    } else if (/eboutique.cebq.sfbu.acpt/.test(hostname)) {
      return environment.acptext.prefix;
    } else if (/eboutique.acptfanniemae.com/.test(hostname)) {
      return environment.acptvanity.prefix;
    } else if (/cebq.cdxms.prod-etss/.test(hostname)) {
      return environment.prod.prefix;
    } else if (/eboutique.cebq.sfbu.prod/.test(hostname)) {
      return environment.prodext.prefix;
    } else if (/eboutique.fanniemae.com/.test(hostname)) {
      return environment.prodvanity.prefix;
    }
  }

  static getLogoutUrl() {
    let url = '';
    const hostname = window && window.location && window.location.hostname;

    if (hostname === 'localhost') {
      url = 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    else if (/cebq.cdxms.devl-etss/.test(hostname)) {
      url = 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    else if (/eboutique.cebq.sfbu.devl/.test(hostname)) {
      // For dev external logout redirect
      url = 'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    else if (/cebq.cdxms.test-etss/.test(hostname)) {
      url = 'https://fmsso-test.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    else if (/eboutique.cebq.sfbu.test/.test(hostname)) {
      // For test external logout redirect
      url = 'https://fmsso-test.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    else if (/cebq.cdxms.acpt-etss/.test(hostname)) {
      url = 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    else if (/eboutique.cebq.sfbu.acpt/.test(hostname)) {
      // For acpt external logout redirect
      url = 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    else if (/eboutique.acptfanniemae/.test(hostname)) {
      // For acpt vanity URL logout redirect
      url = 'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    else {
      url = 'https://fmsso.fanniemae.com/idp/startSLO.ping?TargetResource=https://www.fanniemae.com/';
    }
    return url;
  }

}
